<div class="quote-step-footer">
  <lx-button
    *ngIf="(activeFlow$ | async) !== Flows.Aya"
    buttonStyle="quaternary"
    [btnRounded]="true"
    [block]="true"
    [text]="sendMyQuoteTextButton"
    [icon]="sendMyQuoteIconButton"
    [disabled]="sendMyQuoteDisabledButton"
    (buttonClick)="sendQuote()"
    (keydown.enter)="sendQuote()"
    [lxGAClickEvent]="sendMyQuoteEventName"
    [tabindex]="'-1'"
    tabindex="0"
    data-qa="quoteStepFooter_sendQuote_button"
  ></lx-button>
  <lx-button
    buttonStyle="quaternary"
    [btnRounded]="true"
    [block]="true"
    i18n-text
    text="Start again"
    (buttonClick)="showStartAgainConfirmationDialog($event)"
    (keydown.enter)="showStartAgainConfirmationDialog($event); $event.preventDefault()"
    data-qa="quoteStepFooter_startAgain_button"
    [tabindex]="'-1'"
    tabindex="0"
    [lxGAClickEvent]="createAnotherQuoteEventName"
  ></lx-button>
</div>

<ng-container *ngIf="activeFlow$ | async as activeFlow">
  <ng-container *ngIf="activeFlow === Flows.Junior; else notJunior">
    <p-confirmDialog defaultFocus="accept" styleClass="quote-step-footer__start-again-confirmation-dialog--junior" [dismissableMask]="true"> </p-confirmDialog>
  </ng-container>
  <ng-template #notJunior>
    <p-confirmDialog defaultFocus="accept" styleClass="quote-step-footer__start-again-confirmation-dialog--adult" [dismissableMask]="true"> </p-confirmDialog>
  </ng-template>
</ng-container>
